export default __webpack_public_path__ + "locales/bg/FilesSettings.json?hash=def47c3e49e48df914f3c521f1d7ebc8";